module.exports = __webpack_public_path__ + "static/media/meh-blank.642aeca3.svg";